import * as net from 'util/Net';

import {
  ReviewCriterion,
  ReviewCriterionStatus,
  SavedReviewCriteriaGroup,
  SavedReviewCriterion,
} from './ReviewCriteriaConstants';

export function fetchReviewCriteriaGroups(
  linkedItemId: string
): Promise<{data: Array<SavedReviewCriteriaGroup>}> {
  return Promise.resolve(net.getJSON(`/1/api/review-criteria-groups?linkedItemId=${linkedItemId}`));
}

export function createReviewCriteriaGroup(
  linkedItemId: string,
  name: string,
  reviewCriteria: Array<ReviewCriterion>
): Promise<SavedReviewCriteriaGroup> {
  return Promise.resolve(
    net.postJSON({
      url: '/1/api/review-criteria-groups',
      data: {linkedItemId, name, reviewCriteria},
    })
  );
}

export function updateReviewCriteriaGroup(
  groupId: string,
  name: string,
  reviewCriteria: Array<SavedReviewCriterion>
): Promise<SavedReviewCriteriaGroup> {
  return Promise.resolve(
    net.patchJSON({
      url: `/1/api/review-criteria-groups/${groupId}`,
      data: {name, reviewCriteria},
    })
  );
}

export function deleteReviewCriteriaGroup(groupId: string): Promise<void> {
  return Promise.resolve(net.delete_({url: `/1/api/review-criteria-groups/${groupId}`}));
}

export function updateReviewCriterion(
  criterionId: string,
  data: {status: ReviewCriterionStatus}
): Promise<{criterion: SavedReviewCriterion}> {
  return Promise.resolve(
    net.patchJSON({
      url: `/1/api/review-criterion/${criterionId}`,
      data,
    })
  );
}
